export default function EmploymentOpportunities() {
  return (
    <section className="py-24 px-6 bg-gradient-to-b from-[#F5F9F6] to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-white mb-6">
            <i className="ri-briefcase-line text-[#2D7A3E] text-lg mr-2"></i>
            <span className="text-[#2D7A3E] text-sm font-semibold whitespace-nowrap">新しい雇用の創出</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A2332] mb-6">
            地域に安定した<br />
            雇用を生み出す
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            陸上養殖事業を通じて、地域に100名以上の新しい雇用を創出。<br />
            多様な職種で、幅広い年齢層の方々に働く機会を提供します。
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div className="order-2 md:order-1">
            <h3 className="text-3xl font-bold text-[#1A2332] mb-6">
              多様な雇用機会
            </h3>
            <p className="text-gray-600 mb-8 leading-relaxed">
              養殖作業から施設管理、品質管理、営業まで、様々な職種で地域の方々を雇用します。経験や年齢を問わず、丁寧な研修制度で安心して働ける環境を整えています。
            </p>
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-white p-6 rounded-xl border border-[#E8F5E9]">
                <p className="text-3xl font-bold text-[#2D7A3E] mb-2">100+</p>
                <p className="text-sm text-gray-600 whitespace-nowrap">雇用創出目標</p>
              </div>
              <div className="bg-white p-6 rounded-xl border border-[#E8F5E9]">
                <p className="text-3xl font-bold text-[#2D7A3E] mb-2">15種</p>
                <p className="text-sm text-gray-600 whitespace-nowrap">職種バリエーション</p>
              </div>
              <div className="bg-white p-6 rounded-xl border border-[#E8F5E9]">
                <p className="text-3xl font-bold text-[#2D7A3E] mb-2">365日</p>
                <p className="text-sm text-gray-600 whitespace-nowrap">安定した雇用</p>
              </div>
              <div className="bg-white p-6 rounded-xl border border-[#E8F5E9]">
                <p className="text-3xl font-bold text-[#2D7A3E] mb-2">充実</p>
                <p className="text-sm text-gray-600 whitespace-nowrap">研修制度</p>
              </div>
            </div>
          </div>
          <div className="order-1 md:order-2">
            <img
              src="https://public.readdy.ai/ai/img_res/a6806ad6fb33aaa614b051852abab580.jpg"
              alt="雇用創出"
              className="w-full h-[500px] object-cover object-top rounded-xl"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-4 gap-6">
          <div className="bg-white p-6 rounded-xl border border-[#E8F5E9]">
            <div className="w-12 h-12 bg-[#2D7A3E] rounded-lg flex items-center justify-center mb-4">
              <i className="ri-water-flash-line text-white text-xl"></i>
            </div>
            <h4 className="font-semibold text-[#1A2332] mb-2">養殖作業</h4>
            <p className="text-sm text-gray-600 leading-relaxed">
              給餌、水質管理、魚の健康チェックなど
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl border border-[#E8F5E9]">
            <div className="w-12 h-12 bg-[#2D7A3E] rounded-lg flex items-center justify-center mb-4">
              <i className="ri-settings-line text-white text-xl"></i>
            </div>
            <h4 className="font-semibold text-[#1A2332] mb-2">施設管理</h4>
            <p className="text-sm text-gray-600 leading-relaxed">
              設備メンテナンス、システム監視など
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl border border-[#E8F5E9]">
            <div className="w-12 h-12 bg-[#2D7A3E] rounded-lg flex items-center justify-center mb-4">
              <i className="ri-microscope-line text-white text-xl"></i>
            </div>
            <h4 className="font-semibold text-[#1A2332] mb-2">品質管理</h4>
            <p className="text-sm text-gray-600 leading-relaxed">
              水質検査、製品検査、衛生管理など
            </p>
          </div>
          <div className="bg-white p-6 rounded-xl border border-[#E8F5E9]">
            <div className="w-12 h-12 bg-[#2D7A3E] rounded-lg flex items-center justify-center mb-4">
              <i className="ri-line-chart-line text-white text-xl"></i>
            </div>
            <h4 className="font-semibold text-[#1A2332] mb-2">営業・管理</h4>
            <p className="text-sm text-gray-600 leading-relaxed">
              販売、経理、総務などの事務業務
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}